module.exports = __webpack_public_path__ + "static/media/9DESA31.4c31c929.jpg";